module.exports = __webpack_public_path__ + "static/media/leaves-left.d04aeea3.svg";